import Vue from 'vue'
import Router from 'vue-router'
import Dashboard from './views/Dashboard.vue'
import eTerminal from './views/eTerminal.vue'
import Login from './views/Login.vue'
import Transactions from './views/Transactions.vue'
import ExpiredCardsReport from './views/ExpiredCardsReport.vue'
import PayByLink from './views/PayByLink.vue'
import PayByLinkPayment from './views/PayByLinkPayment.vue'
import AddClient from './views/AddClient.vue'
import SearchClients from './views/SearchClients.vue'
import Client from './views/Client.vue'
import AccountCredentials from './views/AccountCredentials.vue'
import BookingForm from './views/BookingForm.vue'
import OnBoarder from './views/OnBoarder.vue'
import TransactionsAnalysis from './views/TransactionsAnalysis.vue'
import SmsReport from './views/SmsReport.vue'
import CardAttempts from './views/CardAttempts.vue'
import AddUser from './views/AddUser.vue'
import EditUser from './views/EditUser.vue'
import store from './store';

Vue.use(Router)

const router = new Router({

  routes: [
    {
      path: '/',
      name: 'dashboard',
      component: Dashboard,
      beforeEnter(to, from, next) {
        if(localStorage.token) {
          next()
        } else {
          next('/login')
        }
      }
    },
    {
      path: '/transactions',
      name: 'transactions',
      component: Transactions,
      beforeEnter(to, from, next) {
        if(localStorage.token) {
          next()
        } else {
          next('/login')
        }
      }
    },
    {
      path: '/eterminal',
      name: 'eTerminal',
      component: eTerminal,
      beforeEnter(to, from, next) {
        if(localStorage.token) {
          next()
        } else {
          next('/login')
        }
      }
    },
    {
      path: '/expired-cards-report',
      name: 'expired-cards-report',
      component: ExpiredCardsReport,
      beforeEnter(to, from, next) {
        if(localStorage.token) {
          next()
        } else {
          next('/login')
        }
      }
    },
    {
      path: '/login',
      name: 'login',
      component: Login,
      beforeEnter(to, from, next) {
        if(!localStorage.getItem('token')) {
          next()
        }
        else {
          next('/')
        }
      }
    },
    {
      path: '/pay-by-link',
      name: 'pay-by-link',
      component: PayByLink,
      beforeEnter(to, from, next) {
        if(localStorage.token) {
          if(localStorage.sub_page_access.split(",").indexOf('19') == -1 && localStorage.page_access != 'null') {
            next('/holidays');
          }
          else {
            next();
          }
        } else {
          next('/login');
        }
      }
    },
    {
      path: '/pay-by-link-payment/:id',
      name: 'pay-by-link-payment',
      component: PayByLinkPayment,
      beforeEnter(to, from, next) {
        next();
      }
    },
    {
      path: '/add-client',
      name: 'add-client',
      component: AddClient,
      beforeEnter(to, from, next) {
        next();
      }
    },
    {
      path: '/client/:id',
      name: 'client',
      component: Client,
      beforeEnter(to, from, next) {
        next();
      }
    },
    {
      path: '/search-clients',
      name: 'search-clients',
      component: SearchClients,
      beforeEnter(to, from, next) {
        next();
      }
    },
    {
      path: '/account-credentials',
      name: 'account-credentials',
      component: AccountCredentials,
      beforeEnter(to, from, next) {
        next();
      }
    },
    {
      path: '/booking-form',
      name: 'booking-form',
      component: BookingForm,
      beforeEnter(to, from, next) {
        next();
      }
    },
    {
      path: '/transactions-analysis',
      name: 'transactions-analysis',
      component: TransactionsAnalysis,
      beforeEnter(to, from, next) {
        next();
      }
    },
    {
      path: '/card-attempts',
      name: 'card-attempts',
      component: CardAttempts,
      beforeEnter(to, from, next) {
        next();
      }
    },
    {
      path: '/sms-report',
      name: 'sms-report',
      component: SmsReport,
      beforeEnter(to, from, next) {
        next();
      }
    },
    {
      path: '/onboarder',
      name: 'onboarder',
      component: OnBoarder,
      beforeEnter(to, from, next) {
        next();
      }
    },
    {
      path: '/add-user',
      name: 'add-user',
      component: AddUser,
      beforeEnter(to, from, next) {
        next();
      }
    },
    {
      path: '/edit-user',
      name: 'edit-user',
      component: EditUser,
      beforeEnter(to, from, next) {
        next();
      }
    },
    {
      path: '/logout',
      name: 'logout',
      beforeEnter(to, from, next) {
        if(localStorage.getItem('token')) {
          store.state.idToken = null;
          localStorage.removeItem('token');
          next('/login')
        }
      }
    },
  ],
  mode: 'history'
})

router.beforeResolve((to, from, next) => {

  if(localStorage.token && from.name != 'login' && to.name != 'login') {
    store.dispatch('autoLogin')
    .then(response => {
      if(response) {
        store.dispatch('getNavigation');
        next();
      }
      else {
        router.go('/login');
      }
    })
    .catch(err => {
      console.log(err);
    });
  }
  else if(from.name && !localStorage.token) {
    router.go('/login');
  }
  else {
    next();
  }
});

export default router;